export const styles = {
  inputLength: {
    fontSize: '12px',
    color: '#526181',
    marginTop: '10px',
  },
}
